import { ReactComponent as SettingIcon } from '../../../../images/settingNonCircle.svg';
import { FormatDate } from '../../../../utils/formatDate';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import '../../../../css/machines/chiffreClePart.css';

const ChiffreClePart = () => {

    const { t } = useTranslation();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const hasContract = machineDetailsData?.contract_machine?.length > 0;

    return (
        <Box className='chiffreClePart_main_box'>
            <Box className='chiffreClePart_cards_Box'>
                <Box className='chiffreClePart_card'>
                    <Box className='chiffreClePart_card_icon_typo_box'>
                        <SettingIcon className={`chiffreClePart_icon ${!hasContract ? 'no-contract' : ''}`} />
                        <Typography className='chiffreClePart_text_bold'>{t('Maintenance')}</Typography>
                    </Box>

                    <Box className='chiffreClePart_title_content_box'>
                        <Box className='chiffreClePart_box_typography'>
                            <Box className='chiffreClePart_response_box'>
                                <Typography className='chiffreClePart_text_normal'>{t('Entreprise :')}</Typography>
                                {machineDetailsData?.contract_machine?.length > 0 ?
                                    <Typography className='chiffreClePart_text_localisation'>{machineDetailsData?.contract_machine[0]?.contract_date?.contract?.company?.name}</Typography>
                                    :
                                    <Typography className='chiffreClePart_text_normal'>--</Typography>
                                }
                            </Box>
                            <Box className='chiffreClePart_response_box'>
                                <Typography className='chiffreClePart_text_normal'>{t('Date de début de contrat :')}</Typography>
                                {FormatDate(machineDetailsData?.contract_machine[0]?.contract_date?.contract?.firstPeriodStartDate) ?
                                    <Typography className='chiffreClePart_text_localisation'>{FormatDate(machineDetailsData?.contract_machine[0]?.contract_date?.contract?.firstPeriodStartDate)}</Typography>
                                    :
                                    <Typography className='chiffreClePart_text_normal'>--</Typography>
                                }
                            </Box>
                            <Box className='chiffreClePart_response_box'>
                                <Typography className='chiffreClePart_text_normal'>{t('Date de fin de contrat :')}</Typography>
                                {FormatDate(machineDetailsData?.contract_machine[0]?.contract_date?.contract?.lastPeriodEndDate) ?
                                    <Typography className='chiffreClePart_text_localisation'>{FormatDate(machineDetailsData?.contract_machine[0]?.contract_date?.contract?.lastPeriodEndDate)}</Typography>
                                    :
                                    <Typography className='chiffreClePart_text_normal'>--</Typography>
                                }
                            </Box>
                            {machineDetailsData?.contract_machine[0]?.contract_date?.contract?.company?.company_contact?.length > 0 &&
                                <Divider />
                            }
                            {machineDetailsData?.contract_machine[0]?.contract_date?.contract?.company?.company_contact?.map((contact, index) => (
                                <Box className='chiffreClePart_box_typography' key={index}>
                                    <Box className='chiffreClePart_response_box'>
                                        <Typography className='chiffreClePart_text_normal'>{t('Contact :')}</Typography>
                                        {contact?.name ?
                                            <Typography className='chiffreClePart_text_localisation'>{contact?.name}</Typography>
                                            :
                                            <Typography className='chiffreClePart_text_normal'>--</Typography>
                                        }
                                    </Box>
                                    <Box className='chiffreClePart_response_box'>
                                        <Typography className='chiffreClePart_text_normal'>{t('Téléphone :')}</Typography>
                                        {contact?.phone_number ?
                                            <Typography className='chiffreClePart_text_localisation'>{contact?.phone_number}</Typography>
                                            :
                                            <Typography className='chiffreClePart_text_normal'>--</Typography>
                                        }
                                    </Box>
                                    <Box className='chiffreClePart_response_box'>
                                        <Typography className='chiffreClePart_text_normal'>{t('Adresse e-mail :')}</Typography>
                                        {contact?.email ?
                                            <Typography className='chiffreClePart_text_localisation'>{contact?.email}</Typography>
                                            :
                                            <Typography className='chiffreClePart_text_normal'>--</Typography>
                                        }
                                    </Box>
                                    <Box className='chiffreClePart_response_box'>
                                        <Typography className='chiffreClePart_text_normal'>{t('Fonction :')}</Typography>
                                        {contact?.post ?
                                            <Typography className='chiffreClePart_text_localisation'>{contact?.post}</Typography>
                                            :
                                            <Typography className='chiffreClePart_text_normal'>--</Typography>
                                        }
                                    </Box>
                                    <Divider sx={{ borderStyle: 'dashed' }} />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default ChiffreClePart;